export const settings = {
  dots: false,
  infinite: true,
  speed: 100,
  slidesToShow: 10,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 9
      }
    },
    {
      breakpoint: 1055,
      settings: {
        slidesToShow: 8
      }
    },
    {
      breakpoint: 885,
      settings: {
        slidesToShow: 7
      }
    },
    {
      breakpoint: 745,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 545,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 445,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 365,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};